import { Avatar } from "@mui/material";
import React, { useState, useEffect, useRef } from "react";
import axios from "../../../config/axiosConfig";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate } from "react-router-dom";

export const Profile = () => {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("user")));
  const [newImageBase64, setNewImageBase64] = useState(null);
  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const getUserInfo = async () => {
      try {
        const response = await axios.get("/auth/me", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        if (response.data.status === "success") {
          localStorage.setItem("user", JSON.stringify(response.data.data));
          setUser(response.data.data);
        }
      } catch (error) {
        console.log(error);
      }
    };
    getUserInfo();
  }, []);

  const handleImageChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = function (e) {
        const base64String = e.target.result;
        setNewImageBase64(base64String);
      };

      reader.readAsDataURL(file);
    }
  };

  const handleUpdateProfile = async () => {
    setLoading(true);
    // Example:
    try {
      // Send newImageBase64 to your server and update the user's profile
      const response = await axios.put(
        "/auth/profile-picture",
        { image: newImageBase64 },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response.data.status === "success") {
        // Update the `user` state with the new user data
        setUser(response.data.data);
        setNewImageBase64(null); // Clear the new image
      } else {
        // Handle the case where the update failed
        console.log("Profile update failed");
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  // const handleAvatarClick = () => {
  //   // Trigger the file input when the avatar is clicked
  //   if (fileInputRef.current) {
  //     fileInputRef.current.click();
  //   }
  // };

  return (
    <div className="w-full my-2 h-[80.5vh] flex justify-center items-center flex-col pb-32">
      <label className="cursor-pointer">
        <Avatar
          alt={user?.name}
          src={newImageBase64 || user?.image}
          sx={{
            width: 200,
            height: 200,
            borderRadius: "40%",
            cursor: "pointer", // Added cursor: pointer
          }}
          className="clickable" // Added a clickable class
        />
        <input
          type="file"
          accept="image/*"
          className="hidden"
          onChange={handleImageChange}
          ref={fileInputRef}
        />
      </label>
      <p className="mt-4 font-bold text-xl">{user?.name}</p>
      <p className="mt-2 ">{user?.email}</p>

      {newImageBase64 && (
        <button
          className="bg-blue-500 text-white px-4 py-2 rounded-md mt-2"
          onClick={handleUpdateProfile}
        >
          {loading ? (
            <CircularProgress color="inherit" size={15} className="mx-3" />
          ) : (
            "Save"
          )}
        </button>
      )}

      <button
        className="bg-[#FF000F] text-white px-14 py-2 rounded-md absolute bottom-[15vh] font-bold"
        onClick={() => {
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          navigate("/login");
        }}
      >
        Log out
      </button>
    </div>
  );
};
